import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/views/devices.vue')
    },
    {
      path: '/app',
      name: 'app',
      href: 'https://play.google.com/store/apps/details?id=com.brmja.octowhats&hl=ar',
      component: () => import('@/views/app.vue')
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/views/admins.vue')
    },
    {
      path: '/forwards',
      name: 'forwards',
      component: () => import('@/views/chat/forwards.vue')
    },
    {
      path: '/stats',
      name: 'stats',
      component: () => import('@/views/stats.vue')
    },
    {
      path: '/ai',
      name: 'ai',
      component: () => import('@/views/ai.vue')
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import('@/views/tags.vue')
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/orders.vue')
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: () => import('@/views/subscribe.vue')
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('@/views/chat/chat.vue'),
   
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
      },
    },
    {
      path: '/chat-app',
      name: 'chatapp',
      component: () => import('@/views/chat/chat.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
      },
    },
    {
      path: '/device-chat/:jwt/:d/:f',
      name: 'device-chat',
      component: () => import('@/views/chat/device-chat.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/autologin/:id',
      name: 'autologin',
      component: () => import('@/views/pages/autologin.vue')
    },
    {
      path: '/autologin2',
      name: 'autologin2',
      component: () => import('@/views/pages/autologin.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/pages/register.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/activate',
      name: 'activate',
      component: () => import('@/views/pages/activate.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/pages/logout.vue')
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      name: 'error-4042',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
